export const BE05_TABLE_ID = "be05";

export const CMS_FIELDS = {
  IMAGE: "image",
  TITLE: "title",
  DESCRIPTION: "description",
} as const;

export const CMS_SECTION_FIELDS = {
  HEADING: "sectionHeading",
  CARD: "card",
} as const;
